import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import { MapState, StoreKeys, initialState } from './mapStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.SET_MAP_LATITUDE]: (mapLatitude: string | undefined) =>
    set({ mapLatitude }),
  [StoreKeys.SET_MAP_LONGITUDE]: (mapLongitude: string | undefined) =>
    set({ mapLongitude }),
  [StoreKeys.SET_MAP_SEARCH_RADIUS]: (mapSearchRadius: number | undefined) =>
    set({ mapSearchRadius }),
});

const mapStore = persist(store, {
  name: 'mapStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState: MapState, currentState: MapState) => ({
    ...currentState,
    ...persistedState,
  }),
});

export const useMapStore = create(devtools(mapStore));
